import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { z } from "zod";

export const filterDelayedJobsSchema = z.object({
  id_equals: z.number().optional(),
  priority_greater_than: z.number().optional(),
  attempts_greater_than: z.number().optional(),
  owner_id_equals: z.number().optional(),

  handler_contains: z.string().nullable().optional(),
  last_error_contains: z.string().nullable().optional(),
  locked_by_contains: z.string().nullable().optional(),
  queue_contains: z.string().nullable().optional(),
  owner_action_contains: z.string().nullable().optional(),
  owner_type_contains: z.string().nullable().optional(),

  run_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  run_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),

  locked_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  locked_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),

  failed_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  failed_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),

  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),

  updated_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  updated_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),

  calculation_start_date_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  calculation_start_date_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterDelayedJobsSchema = z.infer<typeof filterDelayedJobsSchema>;

export const fields: Field[] = [
  {
    name: "id_equals",
    label: "ID",
    type: "input",
    input_type: "number",
    allowZero: true,
    allowNegative: false,
  },
  {
    name: "priority_greater_than",
    label: "Priority Greater Than",
    type: "input",
    input_type: "number",
    allowZero: true,
    allowNegative: false,
  },
  {
    name: "attempts_greater_than",
    label: "Attempts Greater Than",
    type: "input",
    input_type: "number",
    allowZero: true,
    allowNegative: false,
  },
  {
    name: "owner_id_equals",
    label: "Owner ID",
    type: "input",
    input_type: "number",
    allowZero: true,
    allowNegative: false,
  },

  {
    name: "handler_contains",
    label: "Handler",
    type: "input",
  },
  {
    name: "last_error_contains",
    label: "Last Error",
    type: "input",
  },
  {
    name: "locked_by_contains",
    label: "Locked By",
    type: "input",
  },
  {
    name: "queue_contains",
    label: "Queue",
    type: "input",
  },
  {
    name: "owner_action_contains",
    label: "Owner Action",
    type: "input",
  },
  {
    name: "owner_type_contains",
    label: "Owner Type",
    type: "input",
  },

  // Date fields at the end
  {
    name: "run_at_from",
    label: "Run At From",
    type: "date",
  },
  {
    name: "run_at_to",
    label: "Run At To",
    type: "date",
  },
  {
    name: "locked_at_from",
    label: "Locked At From",
    type: "date",
  },
  {
    name: "locked_at_to",
    label: "Locked At To",
    type: "date",
  },
  {
    name: "failed_at_from",
    label: "Failed At From",
    type: "date",
  },
  {
    name: "failed_at_to",
    label: "Failed At To",
    type: "date",
  },
  {
    name: "created_at_from",
    label: "Created At From",
    type: "date",
  },
  {
    name: "created_at_to",
    label: "Created At To",
    type: "date",
  },
  {
    name: "updated_at_from",
    label: "Updated At From",
    type: "date",
  },
  {
    name: "updated_at_to",
    label: "Updated At To",
    type: "date",
  },
  {
    name: "calculation_start_date_from",
    label: "Calculation Start Date From",
    type: "date",
  },
  {
    name: "calculation_start_date_to",
    label: "Calculation Start Date To",
    type: "date",
  },
];

export const client = "legacy-quantilia";

export function FilterDelayedJobs() {
  return (
    <FilterTable
      client={client}
      schema={filterDelayedJobsSchema}
      tableName="delayed_jobs"
      customBuildPath={() => `${client}/delayed_jobs`}
      fields={fields}
      columns={4}
    />
  );
}
